import { Injectable } from '@angular/core';
import { DictionaryCacheService } from './icache-service';
import { IValueTextPair, ValueTextPair } from 'src/app/shared/models/value-text-pair';
import { SystemcodeApi } from '../api-service/system-code/systemcode-api';
import { EasyNotificationService } from '../easy-notification.service';
import { UserApi } from '../api-service/user/user-api';
import { HistApi } from '../api-service/hist/hist-api';
import { PCSxApiService } from '../api-service/opd/pcsx/pcsx-api';
import { ReportApi } from 'src/app/system/report/reportApi';

export enum OptionTypes{
  Doctors = 'Dcotors',
  Pharmacist = 'Pharmacist',
  SpcTOption='SpcTOption',
  PCSx2014 ='PCSx2014',
  PCSx2023 = 'PCSx2023',
}
@Injectable({
  providedIn: 'root'
})
/** 各式不常變動的選項快取 */
export class OptionsCachedService extends DictionaryCacheService<OptionTypes,IValueTextPair<any>[]> {
  constructor(private userApi: UserApi, 
    private histApi:HistApi,private reportApi:ReportApi,
    private pCSxApiService:PCSxApiService,
    private notifyService: EasyNotificationService) {
    super(notifyService);
   }
  protected notifyMsgOnUpdated: string = '暫存內容已變更…'
  protected notifyMsgOnReload: string = '已重載暫存內容'
  protected cache: Map<OptionTypes, IValueTextPair<any>[]> = new Map();
  protected async getCacheObject(keys: OptionTypes[]): Promise<Map<OptionTypes, IValueTextPair<string>[]|IValueTextPair<number>[]>> {
    var map:Map<OptionTypes, IValueTextPair<string>[]|IValueTextPair<number>[]> = new Map();
    for(let k of keys){
      switch(k){
        case OptionTypes.Doctors:
          const doctor = await this.userApi.GetDoctors();
          map.set(k,doctor);
          break;
        case OptionTypes.Pharmacist:
          const phar = await this.userApi.GetPharmarcist();
          map.set(OptionTypes.Pharmacist,
              phar.filter(x=>x.ext2==true) //IsEnable
                .map(x=>{
                  return {
                    value:x.extension,//Id
                    text:x.text, //Name
                    extension:x.value //CID
                  }
                }));
          break;
        case OptionTypes.SpcTOption:
          const spcOpt = await this.histApi.GetSPCOptions();
          map.set(k,spcOpt);
          break;
        case OptionTypes.PCSx2014:
          var ret2014 = await this.pCSxApiService.GetPCSxPageList({
            pageSize: 200, pageSkip: 0, IsPage: false, DiagVersion: '2014'
          })
          map.set(OptionTypes.PCSx2014,ret2014.data.map(x=>{return {value:x.ApplyCode,text:x.CName}}));
          break;
        case OptionTypes.PCSx2023:
          var ret2023 = await this.pCSxApiService.GetPCSxPageList({
            pageSize: 200, pageSkip: 0, IsPage: false, DiagVersion: '2023'
          });
          map.set(OptionTypes.PCSx2023,ret2023.data.map(x=>{return {value:x.ApplyCode,text:x.CName}}));
          break;
      }
    }
    return map;
  }
}
